/**
 * @generated SignedSource<<c464f3cb84acc3d1e9e85e0fac8c1c1a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LegalClassification = "ARTS" | "EMTS" | "NONE" | "OTHER";
export type TransactionCategory = "CORPORATE_ACTION" | "CRYPTO_ACTION" | "CRYPTO_TRANSFER" | "FIAT_TRANSFER" | "NON_USER_INITIATED" | "STAKING" | "TRADE";
export type TransactionDirection = "INCOMING" | "OUTGOING";
export type TransactionStatus = "CANCELED" | "CREATED" | "CREDITED" | "EXPIRED" | "FAILED" | "FINISHED" | "IN_PROGRESS" | "REFUNDED" | "REJECTED";
export type CorporateActionViewQuery$variables = {
  id: string;
};
export type CorporateActionViewQuery$data = {
  readonly corporateAction: {
    readonly __typename: string;
    readonly asset: {
      readonly id: string;
      readonly legalClassification: LegalClassification | null | undefined;
      readonly logoUrl: string | null | undefined;
      readonly name: string | null | undefined;
      readonly symbol: string | null | undefined;
    } | null | undefined;
    readonly assetAmount: PrecisionFloat | null | undefined;
    readonly category: TransactionCategory;
    readonly childrenTransactions?: ReadonlyArray<{
      readonly asset: {
        readonly id: string;
        readonly legalClassification: LegalClassification | null | undefined;
        readonly logoUrl: string | null | undefined;
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      } | null | undefined;
      readonly assetAmount: PrecisionFloat | null | undefined;
      readonly direction: TransactionDirection | null | undefined;
      readonly fiat: {
        readonly id: string;
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      } | null | undefined;
      readonly fiatAmount: PrecisionFloat | null | undefined;
      readonly id: string;
    }> | null | undefined;
    readonly direction: TransactionDirection | null | undefined;
    readonly fiat: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly symbol: string | null | undefined;
    } | null | undefined;
    readonly fiatAmount: PrecisionFloat | null | undefined;
    readonly id: string;
    readonly spread: PrecisionFloat | null | undefined;
    readonly status: TransactionStatus | null | undefined;
    readonly time: TimeScalar | null | undefined;
  } | null | undefined;
};
export type CorporateActionViewQuery = {
  response: CorporateActionViewQuery$data;
  variables: CorporateActionViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "time",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legalClassification",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "spread",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetAmount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatAmount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Fiat",
  "kind": "LinkedField",
  "name": "fiat",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v7/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "direction",
  "storageKey": null
},
v17 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "childrenTransactions",
    "plural": true,
    "selections": [
      (v3/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v13/*: any*/),
      (v16/*: any*/)
    ],
    "storageKey": null
  }
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "asset",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ],
  "storageKey": null
},
v19 = [
  {
    "alias": null,
    "args": null,
    "concreteType": null,
    "kind": "LinkedField",
    "name": "childrenTransactions",
    "plural": true,
    "selections": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v15/*: any*/),
      (v14/*: any*/),
      (v18/*: any*/),
      (v13/*: any*/),
      (v16/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CorporateActionViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "corporateAction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v17/*: any*/),
            "type": "MergerCryptoTransaction",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v17/*: any*/),
            "type": "MergerStockTransaction",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v17/*: any*/),
            "type": "SpinOffTransaction",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CorporateActionViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "corporateAction",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v18/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v19/*: any*/),
            "type": "MergerCryptoTransaction",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v19/*: any*/),
            "type": "MergerStockTransaction",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v19/*: any*/),
            "type": "SpinOffTransaction",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7aa66093e98bf90bd783dbf37bdf82ff",
    "id": null,
    "metadata": {},
    "name": "CorporateActionViewQuery",
    "operationKind": "query",
    "text": "query CorporateActionViewQuery(\n  $id: ID!\n) {\n  corporateAction(id: $id) {\n    __typename\n    id\n    category\n    status\n    time\n    asset {\n      __typename\n      id\n      name\n      logoUrl\n      symbol\n      legalClassification\n    }\n    spread\n    assetAmount\n    fiatAmount\n    fiat {\n      id\n      name\n      symbol\n    }\n    direction\n    ... on MergerCryptoTransaction {\n      childrenTransactions {\n        __typename\n        id\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        asset {\n          __typename\n          id\n          name\n          logoUrl\n          symbol\n          legalClassification\n        }\n        assetAmount\n        direction\n      }\n    }\n    ... on MergerStockTransaction {\n      childrenTransactions {\n        __typename\n        id\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        asset {\n          __typename\n          id\n          name\n          logoUrl\n          symbol\n          legalClassification\n        }\n        assetAmount\n        direction\n      }\n    }\n    ... on SpinOffTransaction {\n      childrenTransactions {\n        __typename\n        id\n        fiat {\n          id\n          name\n          symbol\n        }\n        fiatAmount\n        asset {\n          __typename\n          id\n          name\n          logoUrl\n          symbol\n          legalClassification\n        }\n        assetAmount\n        direction\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f977cbf29102645f72e443afb982349";

export default node;
